import * as React from 'react';
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from '@mui/material';

import useLocales from '../../../hooks/useLocales';
import FTRecentOperationsTable from '../list/FTRecentOperationsTable';
import {
    fetchFTFuelTankOperationsById,
    selectFTFuelTankOperationsById,
} from '../../../redux/slices/ftFuelTanksSlice';

FTRecentOperationsModal.propTypes = {
    passedData: PropTypes.any,
    open: PropTypes.bool,
    handleClose: PropTypes.func,
};

export default function FTRecentOperationsModal({ passedData, open, handleClose }) {
    const dispatch = useDispatch();
    const { translate } = useLocales();
    const operations = useSelector(selectFTFuelTankOperationsById);

    useEffect(() => {
        if (open && passedData) {
            dispatch(fetchFTFuelTankOperationsById(passedData));
        }
    }, [dispatch, open, passedData]);

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md" aria-labelledby="ft-recent-operations">
            <DialogTitle id="ft-recent-operations">
                {translate('recentOperations')}
            </DialogTitle>
            <DialogContent dividers>
                <FTRecentOperationsTable data={operations} />
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="primary" onClick={handleClose}>
                    {translate('close')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
